export default __webpack_public_path__ + "static/media/waves-phone.9ed9f0bb.png";